export const issueUrl = (url: string, issueKey: string) => {
  return `https://${url}/browse/${issueKey}`;
};
